import React, {useState} from "react";
import BuscadorTemas from "./DOM/BuscadorTemas";
import BuscadorDenue from "./DOM/BuscadorDenue";
import BuscadorMicrodatos from "./DOM/BuscadorMicrodatos";
import BuscadorTabulados from "./DOM/BuscadorTabulados";
import BuscadorAreasGeograficas from "./DOM/BuscadorAreasGeograficas";
import BuscadorDatosAbiertos from "./DOM/BuscadorDatosAbiertos";
import BuscadorGlosario from "./DOM/BuscadorGlosario";
import BuscadorNoticias from "./DOM/BuscadorNoticias";
import BuscadorEnlace from "./DOM/BuscadorEnlace";
import BuscadorMapas from "./DOM/BuscadorMapas";
import BuscadorPublicaciones from "./DOM/BuscadorPublicaciones";
import BuscadorInvestigacion from "./DOM/BuscadorInvestigacion";
import BuscadorInfraestructura from "./DOM/BuscadorInfraestructura";
import BuscadorBie from "./DOM/BuscadorBie";
import BuscadorBieBise from "./DOM/BuscadorBieBise";
import BuscadorIndicadores from "./DOM/BuscadorIndicadores";
import BuscadorProgramas from "./DOM/BuscadorProgramas";
import BuscadorTodo from "./DOM/BuscadorTodo";
import {useStoreGlobal} from '../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
import SinResultados from "./componentesSecundarios/SinResultados";
import Piepagina from "../componentesHTML/componentesSecundarios/Piepagina";

export default function Resultados() {
    const _filtros = useStoreGlobal(useShallow((state) => state._filtros));
    const _totalBotonClic = useStoreGlobal(useShallow((state) => state._totalBotonClic));
    const _totalAreaGeo = useStoreGlobal(useShallow((state) => state._totalAreaGeo));

    let coleccion = "";
    let camposBuscador = "";
    let camposOrden = "";
    let ordenamiento = "";
    let pageFin = 0;
    let paginaInicial = 0;
    let metodoBusqueda = 1;
    let radioIndicador = "";
    let botonConsulta = 0;
    let textoBusqueda = "";
    let var_area_final = "null";

    if (Object.keys(_filtros).length > 0) {
        coleccion = _filtros.coleccion;
        camposBuscador = _filtros.camposBuscador;
        camposOrden = _filtros.camposOrden;
        ordenamiento = _filtros.ordenamiento;
        pageFin = _filtros.paginaFin;
        paginaInicial = _filtros.paginaInicial;
        metodoBusqueda = _filtros.metodoBusqueda;
        radioIndicador = _filtros.radioIndicador;
        textoBusqueda = _filtros.textoBusqueda;
    }
    if (Object.keys(_totalBotonClic).length > 0) {
        botonConsulta = _totalBotonClic.botonConsulta;
    }
    if (Object.keys(_totalAreaGeo).length > 0) {
        var_area_final = _totalAreaGeo.valorAreaFinal;
    }
    function renderIndicadores() {
        if (radioIndicador === "BancoBise") {
            return (
                <BuscadorIndicadores
                    textoBusqueda={textoBusqueda}
                    camposBuscador={camposBuscador}
                    camposOrden={camposOrden}
                    ordenamiento={ordenamiento}
                    pageInicial={paginaInicial}
                    pageFin={pageFin}
                    metodoBusqueda={metodoBusqueda}
                    var_area_final={var_area_final}
                />
            );
        }
        if (radioIndicador === "BancoBieBise") {
            return (
                // Componente para el BIE
                //<BuscadorBie
                // Componente para el BIEBISE
                 <BuscadorBieBise
                    textoBusqueda={textoBusqueda}
                    camposBuscador={camposBuscador}
                    camposOrden={camposOrden}
                    ordenamiento={ordenamiento}
                    pageInicial={paginaInicial}
                    pageFin={pageFin}
                    metodoBusqueda={metodoBusqueda}
                />
            );
        }
        return null;
    }
    
    function checarTodo() {
        if (camposOrden === "CBUSQUEDA") {
            return "ranking";
        } else if (camposOrden === "VISITAS") {
            return "VISITAS";
        } else if (camposOrden === "RANKING") {
            return "RANKING";
        }else {
            return "ranking";
        }
    }
    function renderBuscador() {
        if (!(botonConsulta === 1 && textoBusqueda !== "")) return null;
        switch (coleccion) {
            case "Todo":
            case "All":
                return (
                    <BuscadorTodo
                        textoBusqueda={textoBusqueda}
                        camposOrden={
                            checarTodo()
                        }
                        metodoBusqueda={metodoBusqueda}
                        var_area_final={var_area_final}
                    />
                );
            case "Areageograficas":
                return (
                    <BuscadorAreasGeograficas
                        textoBusqueda={textoBusqueda}
                        camposBuscador={camposBuscador}
                        camposOrden={camposOrden}
                        ordenamiento={ordenamiento}
                        pageInicial={paginaInicial}
                        pageFin={pageFin}
                        metodoBusqueda={metodoBusqueda}
                    />
                );
            case "Datos_abiertos":
                return (
                    <BuscadorDatosAbiertos
                        textoBusqueda={textoBusqueda}
                        camposBuscador={camposBuscador}
                        camposOrden={camposOrden}
                        ordenamiento={ordenamiento}
                        pageInicial={paginaInicial}
                        pageFin={pageFin}
                        metodoBusqueda={metodoBusqueda}
                    />
                );
            case "DENUE":
                return (
                    <BuscadorDenue
                        textoBusqueda={textoBusqueda}
                        camposBuscador={camposBuscador}
                        camposOrden={camposOrden}
                        ordenamiento={ordenamiento}
                        pageInicial={paginaInicial}
                        pageFin={pageFin}
                        metodoBusqueda={metodoBusqueda}
                    />
                );
            case "Glosario":
                return (
                    <BuscadorGlosario
                        textoBusqueda={textoBusqueda}
                        camposBuscador={camposBuscador}
                        camposOrden={camposOrden}
                        ordenamiento={ordenamiento}
                        pageInicial={paginaInicial}
                        pageFin={pageFin}
                        metodoBusqueda={metodoBusqueda}
                    />
                );
            case "Indicadores":
                return renderIndicadores();
            case "Investigación":
            case "Investigation":
                return (
                    <BuscadorInvestigacion
                        textoBusqueda={textoBusqueda}
                        camposBuscador={camposBuscador}
                        camposOrden={camposOrden}
                        ordenamiento={ordenamiento}
                        pageInicial={paginaInicial}
                        pageFin={pageFin}
                        metodoBusqueda={metodoBusqueda}
                    />
                );
            case "Infraestructura":
            case "Infrastructure":
                return (
                    <BuscadorInfraestructura
                        textoBusqueda={textoBusqueda}
                        camposBuscador={camposBuscador}
                        camposOrden={camposOrden}
                        ordenamiento={ordenamiento}
                        pageInicial={paginaInicial}
                        pageFin={pageFin}
                        metodoBusqueda={metodoBusqueda}
                    />
                );
            case "Mapas":
                return (
                    <BuscadorMapas
                        textoBusqueda={textoBusqueda}
                        camposBuscador={camposBuscador}
                        camposOrden={camposOrden}
                        ordenamiento={ordenamiento}
                        pageInicial={paginaInicial}
                        pageFin={pageFin}
                        metodoBusqueda={metodoBusqueda}
                    />
                );
            case "Microdatos":
                return (
                    <BuscadorMicrodatos
                        textoBusqueda={textoBusqueda}
                        camposBuscador={camposBuscador}
                        camposOrden={camposOrden}
                        ordenamiento={ordenamiento}
                        pageInicial={paginaInicial}
                        pageFin={pageFin}
                        metodoBusqueda={metodoBusqueda}
                    />
                );
            case "Noticias":
                return (
                    <BuscadorNoticias
                        textoBusqueda={textoBusqueda}
                        camposBuscador={camposBuscador}
                        camposOrden={camposOrden}
                        ordenamiento={ordenamiento}
                        pageInicial={paginaInicial}
                        pageFin={pageFin}
                        metodoBusqueda={metodoBusqueda}
                    />
                );
            case "Publicaciones":
                return (
                    <BuscadorPublicaciones
                        textoBusqueda={textoBusqueda}
                        camposBuscador={camposBuscador}
                        camposOrden={camposOrden}
                        ordenamiento={ordenamiento}
                        pageInicial={paginaInicial}
                        pageFin={pageFin}
                        metodoBusqueda={metodoBusqueda}
                    />
                );
            case "Tabulados":
                return (
                    <BuscadorTabulados
                        textoBusqueda={textoBusqueda}
                        camposBuscador={camposBuscador}
                        camposOrden={camposOrden}
                        ordenamiento={ordenamiento}
                        pageInicial={paginaInicial}
                        pageFin={pageFin}
                        metodoBusqueda={metodoBusqueda}
                    />
                );
            case "Temas":
            case "Tools":
                return (
                    <BuscadorTemas
                        textoBusqueda={textoBusqueda}
                        camposBuscador={camposBuscador}
                        camposOrden={camposOrden}
                        ordenamiento={ordenamiento}
                        pageInicial={paginaInicial}
                        pageFin={pageFin}
                        metodoBusqueda={metodoBusqueda}
                    />
                );
            case "Programas":
            case "Programs":
                return (
                    <BuscadorProgramas
                        textoBusqueda={textoBusqueda}
                        camposBuscador={camposBuscador}
                        camposOrden={camposOrden}
                        ordenamiento={ordenamiento}
                        pageInicial={paginaInicial}
                        pageFin={pageFin}
                        metodoBusqueda={metodoBusqueda}
                    />
                );
            case "Herramientas":
                return (
                    <BuscadorEnlace
                        textoBusqueda={textoBusqueda}
                        camposBuscador={camposBuscador}
                        camposOrden={camposOrden}
                        ordenamiento={ordenamiento}
                        pageInicial={paginaInicial}
                        pageFin={pageFin}
                        metodoBusqueda={metodoBusqueda}
                    />
                );
            
        }
    }
    return (
        <div id="contextsearchresults" style={{ display: "block", marginTop: "50px" }} className="col-xs-12 todo">
            <div className="col-xs-12" style={{ paddingLeft: "0px" }} id="result">
                {renderBuscador()}
            </div>
            <SinResultados coleccion={coleccion} />
            {(coleccion !== "Todo" && coleccion !== "All") ? <Piepagina /> : ""}
        </div>
    );
}